<div class="d-flex justify-content-center cover-spin" *ngIf="loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="flex-container" (click)="onMouseClick($event)">
  <div class="horizontal-container m20 alignCenter">
    <div class="fullflex" (click)="selSection('Snapshot')" [ngClass]="selected == 'Snapshot' ? 'selected': ''">
      Snapshot
      <fa-icon [icon]="faInfoCircle" id="SnapshotInfoBtn" (mouseenter)="showHideInfoToggle('SnapshotInfo')" (mouseleave)="showHideInfoToggle('SnapshotInfo')"></fa-icon>
      <div id="divSnapshotInfo">
        <div class="InfoContent">
          This selection will give you a detailed overview of the final report values for the solution you have selected below
        </div>
        <div id="arrow" data-popper-arrow></div>
      </div>
    </div>
    <div class="fullflex" (click)="selSection('Comparison')" [ngClass]="selected == 'Comparison' ? 'selected': ''">
      Comparison 
      <fa-icon [icon]="faInfoCircle" id="ComparisonInfoBtn" (mouseenter)="showHideInfoToggle('ComparisonInfo')" (mouseleave)="showHideInfoToggle('ComparisonInfo')"></fa-icon>
      <div id="divComparisonInfo">
        <div class="InfoContent"> 
          This selection will give you a table showing all the figures from each solution, side by side. <br>
          Comparison is a quick way to see how the final report will look without having to generate it.
        </div>
        <div id="arrow" data-popper-arrow></div>
      </div>
    </div>
  </div>

  <div class="fullwidth" *ngIf="selected == 'Snapshot'">
    <div class="vertical-containers stageBox" style="box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.07);">
      <table width="100%">
        <tr>
          <td width="60%">
            <label>Select a solution</label>
            <div class="horizontal-container">
              <div class="tabs" *ngFor="let solution of solutions" (click)="setState(solution.solutionID)"
                [ngClass]="state == solution.solutionID ? 'selected': ''">
                <span>{{solution.solutionName}}</span>
              </div>
            </div>
          </td>
          <td width="40%">
            <table width="100%">
              <tr>
                <td>
                  <label>Operating Conditions</label>
                </td>
              </tr>
              <tr>
                <td width="30%">
                  {{this.contamination.airflow}} &nbsp; {{this.contamination.airflowUnit}}
                </td>
                <td width="30%">
                  {{this.contamination.temperature}} {{UnitsFromUserData.Temperature}}
                </td>
                <td width="30%">
                  Relative Humidity : {{this.contamination.relativeHumidity}}%
                </td>
              </tr>
            </table>                       
          </td>
        </tr>
      </table>
      <span *ngIf="selectedSolution[0].resultReady===false" class="errorMsg"> Calculation failed for this solution </span>
    </div>    
  </div>

  <div id="divSnapshot" *ngIf="selected == 'Snapshot'" style="width:100%; margin-top:40px;">     
    <div class="flex-nowrap row">
      <div class="col"></div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">     
        <span style="font-weight:500;">Combination of gasses / Gas {{i+1}}</span>     
      </div>
    </div>

    <div class="chartheader">
      Chemical Info
    </div>

    <div class="flex-nowrap row">
      <div class="col">Contamination</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">
        <div *ngFor="let eachGas of item.combinationGas; let j = index;">
          <span>{{eachGas.ContaminationType}}</span>
          <div class="row" style="margin-left:0px !important;">
            <span>{{eachGas.ConcentrationValue}} {{selectedConcUnit}}</span>
          </div>        
          <div class="row" style="margin-left:0px !important;">
            <span>{{eachGas.altConcValue}} {{eachGas.AltConcUnit}}</span>
          </div>
          <div class="row" style="margin-bottom:20px; margin-left:0px !important;">
            <span class="pointer" (click)="moreInfo(i, j)"><img src="assets/images/expand.png" width="25px">{{eachGas.displayTypeForMoreInfo}}</span>
          </div>

          <!-- Display More Information -->
          <div id="divMoreInfoForGas{{i}}{{j}}" class="row moreInfoDisplay" style="display:none;">
            <table width="100%">
              <tr>
                <td width="60%">
                  <span class="moreInfoTitle">Chemical Formula</span>
                </td>
                <td width="40%">
                  <span class="moreInfoContents">{{eachGas.moreInformation.chemicalFormula}}</span>
                </td>
              </tr>
              <tr>
                <td width="60%">
                  <span class="moreInfoTitle">Vapour Pressure</span>
                </td>
                <td width="40%">
                  <span class="moreInfoContents">{{eachGas.moreInformation.vapourPressureValue}} {{UnitsFromUserData.VapourPa}}</span>
                </td>
              </tr>
              <tr>
                <td width="60%">
                  <span class="moreInfoTitle">Molecular Weight</span>
                </td>
                <td width="40%">
                  <span class="moreInfoContents">{{eachGas.moreInformation.molecularWeight}} g/mol</span>
                </td>
              </tr>
              <tr>
                <td width="60%">
                  <span class="moreInfoTitle">Boiling Point</span>
                </td>
                <td width="40%">
                  <span class="moreInfoContents">{{eachGas.moreInformation.boilingPoint}} {{UnitsFromUserData.Temperature}}</span>
                </td>
              </tr>
              <tr>
                <td width="60%">
                  <span class="moreInfoTitle">CAS No</span>
                </td>
                <td width="40%">
                  <span class="moreInfoContents">{{eachGas.moreInformation.casNo}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div> <!-- For Combination Gas Loop -->
      </div> <!-- For Media Loop -->
    </div>

    <div class="chartheader">
      Filters
    </div>

    <div class="flex-nowrap row">
      <div class="col">Filter Group</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span>{{item.molecularGroup}}</span>        
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Filter Type</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span>{{item.molecularType}}</span>       
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Media</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span>{{item.filterName}}</span>       
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Media Database Name</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span>{{item.filterDBName}}</span>       
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">No. of Filters per Stage</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].solutionDetails; let i = index;">        
        <span>{{item.noOfFilter}}</span>       
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Total Filter Stage</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].solutionDetails; let i = index;">        
        <span>{{item.totalStage}}</span>       
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col"></div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].solutionDetails; let i = index;">        
        <div class="hardwareImg">
          <img *ngIf="item.molecularTypePic != ''" src="{{sharedService.filterPhotoPath}}{{item.molecularTypePic}}" style="width:80px; height:70px;">
          <img *ngIf="item.molecularTypePic != ''" src="{{sharedService.filterPhotoPath}}{{item.molecularPic}}" style="width:80px; height:70px;">
        </div>          
      </div>
    </div>
    
    <div class="chartheader">
      Filter Performance
    </div>

    <div class="flex-nowrap row">
      <div class="col">Media Weight</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span *ngIf="item.effMediaWeight != 0">{{item.effMediaWeight}} {{UnitsFromUserData.Weight}}</span>
        <span *ngIf="item.effMediaWeight == 0">NA</span>  
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Total Weight</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span *ngIf="item.totalWeight != 0">{{item.totalWeight}} {{UnitsFromUserData.Weight}}</span>
        <span *ngIf="item.totalWeight == 0">NA</span>
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Front Velocity</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span>{{item.frontVelocity}} {{UnitsFromUserData.Velocity}}</span>       
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Contact Time</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span>{{item.contactTime}} sec</span>       
      </div>
    </div>

    <div class="flex-nowrap row">
      <div class="col">Pressure Drop</div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">        
        <span>{{item.pressureDrop}} {{UnitsFromUserData.PressureDrop}}</span>       
      </div>
    </div>

     <!-- Efficiency vs LifeTime -->
     <div class="flex-nowrap row" style="margin-top:20px;">
      <div class="col" style="font-weight:500;">Efficiency vs Lifetime
        <div *ngIf="sharedService.CalculationForEfficiencyFailed===true" style="font-weight:500; color:red;">Calculation out of range...Please change parameters</div> <!-- Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of selectedSolution[0].results; let i = index;">
        <div id="divEffVsLife{{i}}">

        </div>
      </div>
    </div>

    <div class="chartheader">
      Lifetime Estimation Graph
    </div>

    <div id="divEffvsLifeGraph" style="width:1000px; height:700px;">
      
    </div>
  </div>

  <div class="tableOuter vertical-containers " *ngIf="selected === 'Comparison'">
    <table width="100%">
      <tr>
        <td width="50%">
          <table width="100%">
            <tr>
              <td>
                <label>Operating Conditions</label>
              </td>
            </tr>
            <tr>
              <td width="30%">
                {{this.contamination.airflow}} &nbsp; {{this.contamination.airflowUnit}}
              </td>
              <td width="30%">
                {{this.contamination.temperature}} {{UnitsFromUserData.Temperature}}
              </td>
              <td width="30%">
                Relative Humidity : {{this.contamination.relativeHumidity}}%
              </td>
            </tr>
          </table> 
        </td>
        <td width="50%">

        </td>
      </tr>
    </table>
      
    &nbsp;

    <div class="flex-nowrap row">
      <div class="col"></div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of results; let i = index;">     
        <!-- <span style="font-weight:500;">Solution {{i+1}}</span> -->
        <span style="font-weight:500;">{{item.solutionName}}</span>
      </div>
    </div>

    <div class="chartheader">
      Comparison of Chemicals
    </div>

    <div class="flex-nowrap row">
      <div class="col">
        <div *ngFor="let gas of contamination.gasDetails; let j = index;">             
          <img src="assets/images/{{gas.colorForResultPage}}" style="width:22px; height:22px;"/>
          <!-- Modified by PP(2023-06-07) : Allow same gas diff conc value - START -->
          <!-- <span *ngIf="gas.otherGas===true" style="margin-left:10px;">{{gas.contaminationType}} - {{gas.otherGasDetails.otherContaminantName}}</span>
          <span *ngIf="gas.otherGas===false" style="margin-left:10px;">{{gas.contaminationType}}</span> -->
          <span *ngIf="gas.otherGas===true" style="margin-left:10px;">{{gas.contaminationType}} - {{gas.otherGasDetails.otherContaminantName}} <span style="font-weight:500;">[{{gas.concentrationValue}} {{selectedConcUnit}}]</span></span>
          <span *ngIf="gas.otherGas===false" style="margin-left:10px;">{{gas.contaminationType}} <span style="font-weight:500;">[{{gas.concentrationValue}} {{selectedConcUnit}}]</span></span> 
          <!-- Modified by PP(2023-06-07) : Allow same gas diff conc value - END -->
        </div>
      </div>     
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let item of results; let i = index;">           
        <div class="row">
          <div class="columnForDesc" style="width:80px;">      </div> <!-- Filter -->
          <div *ngFor="let media of item.results; let j = index;">
            <div class="columnForDesc">
              <span *ngIf="item.results.length === 3 && j === 0" style="margin-right:20px;"> </span> <!-- A -->
              <span *ngIf="item.results.length === 3 && j === 1" style="margin-right:20px;"> </span> <!-- B -->
              <span *ngIf="item.results.length === 3 && j === 2" style="margin-right:20px;"> </span> <!-- C -->
              <!-- <span *ngIf="item.results.length === 2 && media.combinationGas.length === 2" style="margin-right:20px;">A</span>
              <span *ngIf="item.results.length === 2 && media.combinationGas.length === 1" style="margin-right:20px;">B</span> -->
              <span *ngIf="item.results.length === 2 && j === 0" style="margin-right:20px;"> </span> <!-- A -->
              <span *ngIf="item.results.length === 2 && j === 1" style="margin-right:20px;"> </span> <!-- B -->
              <span *ngIf="item.results.length === 1" style="margin-right:20px;">A</span> <!-- A -->
            </div>              
          </div>
        </div>

        <div class="row">
          <div class="columnForDesc" style="width:80px;">Gasses</div>
          <div *ngFor="let media of item.results;">
            <div class="columnForDesc">
              <!-- Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-START -->
              <!-- <span *ngIf="item.results.length === 3" style="margin-right:12px;">x1</span>
              <span *ngIf="item.results.length === 2 && media.combinationGas.length === 2" style="margin-right:12px;">x2</span>
              <span *ngIf="item.results.length === 2 && media.combinationGas.length === 1" style="margin-right:12px;">x1</span>
              <span *ngIf="item.results.length === 1" style="margin-right:12px;">x3</span>   -->
              <span *ngIf="media.combinationGas.length === 3" style="margin-right:12px;">x3</span>
              <span *ngIf="media.combinationGas.length === 2" style="margin-right:12px;">x2</span>
              <span *ngIf="media.combinationGas.length === 1" style="margin-right:12px;">x1</span>  
              <!-- Modified by PS(2023-03-27): MCCLD 2023-ASTM Result page: add loading-END -->
            </div>                 
          </div>
        </div>

        <div class="row">
          <div class="columnForDesc" style="width:70px;"></div>
          <div *ngFor="let media of item.results;">
            <div class="columnForDesc">
              <img src="assets/images/{{media.colorForResultPage}}" style="width:30px; height:120px;"/>
            </div>   
               
          </div>
        </div>

      </div>
    </div>

    <div class="chartheader">
      Comparison of Filters
    </div>

    <div class="flex-nowrap row">     
      <div class="col">
        <div class="row" *ngIf="MaxNumOfMedia >= 1" style="margin-left:3px;">Filter</div> <!-- Filter A -->
        <br>
        <br>
        <br>
        <br>
        <div class="row" *ngIf="MaxNumOfMedia >= 2" style="margin-left:3px;">Filter</div> <!-- Filter B -->
        <br>
        <br>
        <br>
        <br>
        <div class="row" *ngIf="MaxNumOfMedia >= 3" style="margin-left:3px;">Filter</div> <!-- Filter C -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let solution of solutions; let i = index;">
        <div *ngFor="let soldet of solution.solutionDetails; let j = index;">
          <div class="row">
            <div class="col">
              <span>{{soldet.molecularGroup}} {{soldet.molecularType}} {{soldet.filterName}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col hardwareImg">
              <img *ngIf="soldet.molecularTypePic != ''" src="{{sharedService.filterPhotoPath}}{{soldet.molecularTypePic}}" style="width:80px; height:70px;">
              <img *ngIf="soldet.molecularPic != ''" src="{{sharedService.filterPhotoPath}}{{soldet.molecularPic}}" style="width:80px; height:70px;">
            </div>
          </div>       
        </div>         
      </div>
    </div>

    <br>

    <div class="flex-nowrap row">     
      <div class="col">
        Total number of filters
        <br>
        <!-- (Filter A / B / C) -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let solution of solutions; let i = index;">
        <div class="columnForDesc" *ngFor="let soldet of solution.solutionDetails; let j = index;">
          <span *ngIf="j === 0">{{soldet.noOfFilter * soldet.totalStage}}</span>
          <span *ngIf="j > 0">/ {{soldet.noOfFilter * soldet.totalStage}}</span>
        </div>         
      </div>
    </div>

    <br>

    <div class="flex-nowrap row">     
      <div class="col">
        Number of stages
        <br>
        <!-- (Filter A / B / C) -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let solution of solutions; let i = index;">
        <div class="columnForDesc" *ngFor="let soldet of solution.solutionDetails; let j = index;">
          <span *ngIf="j === 0">{{soldet.totalStage}}</span>
          <span *ngIf="j > 0">/ {{soldet.totalStage}}</span>
        </div>         
      </div>
    </div>

    <br>

    <div class="flex-nowrap row">     
      <div class="col">
        Number of filters per stage
        <br>
        <!-- (Stage 1 / Stage 2 / Stage 3) -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let solution of solutions; let i = index;">
        <div class="columnForDesc" *ngFor="let soldet of solution.solutionDetails; let j = index;">
          <span *ngIf="j === 0">{{soldet.noOfFilter}}</span>
          <span *ngIf="j > 0">/ {{soldet.noOfFilter}}</span>
        </div>         
      </div>
    </div>

    <br>

    <div class="flex-nowrap row">     
      <div class="col">
        Total Weight [{{UnitsFromUserData.Weight}}]
        <br>
        <!-- (Filter A / B / C) -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let result of results; let i = index;">
        <div class="columnForDesc" *ngFor="let resdet of result.results; let j = index;">
          <span *ngIf="j === 0 && resdet.moreInformation.totalWeight != 0">{{resdet.moreInformation.totalWeight}}</span>
          <span *ngIf="j === 0 && resdet.moreInformation.totalWeight == 0">NA</span>
          <span *ngIf="j > 0 && resdet.moreInformation.totalWeight != 0">/ {{resdet.moreInformation.totalWeight}}</span>
          <span *ngIf="j > 0 && resdet.moreInformation.totalWeight == 0">/ NA</span>
        </div>         
      </div>
    </div>

    <br>

    <div class="chartheader">
      Comparison of Filter Performance
    </div>

    <div class="flex-nowrap row">     
      <div class="col">
        Total pressure drop [{{UnitsFromUserData.PressureDrop}}]
        <br>
        <!-- (Filter A / B / C) -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let result of results; let i = index;">
        <div class="columnForDesc" *ngFor="let resdet of result.results; let j = index;">
          <span *ngIf="j === 0">{{resdet.moreInformation.pressureDrop}}</span>
          <span *ngIf="j > 0">/ {{resdet.moreInformation.pressureDrop}}</span>
        </div>         
      </div>
    </div>

    <br>

    <div class="flex-nowrap row">     
      <div class="col">
        Initial Efficiency [%]
        <br>
        <!-- (Filter A / B / C) -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let result of results; let i = index;">
        <div class="columnForDesc" *ngFor="let resdet of result.results; let j = index;">
          <span *ngIf="j === 0">{{resdet.Efficiency[0]}}</span>
          <span *ngIf="j > 0">/ {{resdet.Efficiency[0]}}</span>
        </div>         
      </div>
    </div>

    <br>

    <div class="flex-nowrap row">     
      <div class="col">
        Lifetime @ 50% Efficiency [Hours]
        <br>
        <!-- (Filter A / B / C) -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let result of results; let i = index;">
        <div class="columnForDesc" *ngFor="let resdet of result.results; let j = index;">
          <span *ngIf="j === 0">{{resdet.LifeTimeHoursFor50PercentForDisplaySign}} {{resdet.LifeTimeHoursFor50Percent}}</span>
          <span *ngIf="j > 0">/ {{resdet.LifeTimeHoursFor50PercentForDisplaySign}} {{resdet.LifeTimeHoursFor50Percent}}</span>
        </div>         
      </div>
    </div>

    <!-- Efficiency vs LifeTime -->
    <div class="flex-nowrap row" style="margin-top:20px;">
      <div class="col" style="font-weight:500;">Efficiency vs Lifetime
        <div *ngIf="sharedService.CalculationForEfficiencyFailed===true" style="font-weight:500; color:red;">Calculation out of range...Please change parameters</div> <!-- Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros -->
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5 vertical-containers" *ngFor="let result of results; let i = index;">
        <div id="divEffVsLifeCompareSol{{i}}">

        </div>
      </div>
    </div>

    <div class="chartheader">
      Lifetime Estimation Graph
    </div>

    <div id="divEffvsLifeComparisonGraph" style="width:1000px; height:700px;">
      
    </div>

  </div>
</div>

<!-- Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros - START -->
<ng-template #calcOutOfRangeWarning let-modal class="overwriteConfirm">
  <div class="modal-contents">
    <div class="modal-header">        
        <h5 class="modal-title" id="exampleModalLongTitle">Efficiency LifeTime Graph Generation Failed</h5>
        <button type="button" class="close" aria-label="Close"  (click)="modal.dismiss(true)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" >
        <div>
            <div class="linkContent">               
                <span class="linkText">Calculation is out of range. Please change the parameters...</span>
            </div>
        </div>
    </div>
    <div class="next-button-content">
        <button style="margin: 10px;"class="button-content ripple" (click)="modal.dismiss(true)" aria-label="Close">            
            OK
        </button>
    </div>
  </div>
</ng-template>
<!-- Modified by PP(2024-06-11) : To pop up message when lifetime is all negative/zeros - END -->

<div class="next-button-content">
    <button class="button-content ripple" (click)='Proceed()'>
        <span class='space'>Next</span> <fa-icon [icon]="faAngleRight"></fa-icon>
    </button>
</div>